import { createAction } from '@reduxjs/toolkit';

export const LOGOUT = 'auth-logout/logout';

export const logout = createAction<{ next?: string } | undefined>(LOGOUT);
